export class AppLocale {
	displayName?: string;
	uiLanguageFile?: string;
	localeId?: string;
	firstDayOfWeek?: number;
	dateFormat: string = "";
	timestampFormat: string = "";
}
